import { render, staticRenderFns } from "./ColorChoice.vue?vue&type=template&id=1ec29251&scoped=true&"
import script from "./ColorChoice.vue?vue&type=script&lang=js&"
export * from "./ColorChoice.vue?vue&type=script&lang=js&"
import style0 from "./ColorChoice.vue?vue&type=style&index=0&id=1ec29251&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec29251",
  null
  
)

export default component.exports